// src/pages/CheckoutPage.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CheckoutPage = ({ cart, updateQuantity, removeFromCart, cartTotal, formatPrice,toggleCartWidget }) => {
  const [checkoutPage, setCheckoutPage] = useState("cart"); // State to manage 'cart' or 'checkout' view
  const [billingDetails, setBillingDetails] = useState({
    firstName: '',
    lastName: '',
    email:'',
    contact: '',
    streetAddress: '',
    apartmentSuite: '',
    townCity: '',
    stateCounty: 'Tamil Nadu', // Default value based on screenshot
    postcodeZIP: '',
  });

  // Effect to handle visibility of cart table vs. empty cart message
  useEffect(() => {
    const cartPageDiv = document.getElementById('wd-cart-page-333');
    const emptyCartMessageDiv = document.getElementById('post-380');

    if (cart.length === 0) {
      if (cartPageDiv) cartPageDiv.style.display = 'none';
      if (emptyCartMessageDiv) emptyCartMessageDiv.style.display = 'block';
    } else {
      if (cartPageDiv) cartPageDiv.style.display = 'block';
      if (emptyCartMessageDiv) emptyCartMessageDiv.style.display = 'none';
    }
      
  }, [cart]);

  useEffect(()=>{
    toggleCartWidget();
  },[])

  // Handle input changes for billing details form
  const handleBillingChange = (e) => {
    const { name, value } = e.target;
      let sanitizedValue = value;

  // Allow only numbers for contactNumber or phone fields
  if (name === 'contact' || name === 'phone' ) {
    sanitizedValue = value.replace(/[^0-9]/g, '');
  }
  if(name === 'postcodeZIP'){
     sanitizedValue = value.replace(/[^0-9]/g, '');
  }
    setBillingDetails((prevDetails) => ({
      ...prevDetails,
      [name]: sanitizedValue,
    }));
  };

  // Handle form submission (placeholder for actual payment processing)
  const handleSubmitOrder = (e) => {
    e.preventDefault();
    // In a real application, you would send billingDetails and cart data to a backend
    console.log("Submitting order with:", billingDetails, cart);
    // Simulate order completion for now
    setCheckoutPage("order-complete");
    // Clear cart after successful order (optional, depending on flow)
    // setCart([]);
  };

  return (
    <>
      {/* Page Title Section */}
      <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
        <div className="container">
          <ul className="wd-checkout-steps">
            <li className={`step-cart ${checkoutPage === "cart" ? 'step-active' : 'step-inactive'}`}>
              <span onClick={() => setCheckoutPage("cart")}>Shopping cart</span>
            </li>
            <li className={`step-checkout ${cart.length === 0 ? 'step-disabled step-inactive' : (checkoutPage === "checkout" ? 'step-active' : 'step-inactive')}`}>
              <span onClick={() => { if (cart.length > 0) setCheckoutPage("checkout"); }}>Checkout</span>
            </li>
            <li className={`step-complete ${checkoutPage === "order-complete" ? 'step-active' : 'step-inactive'}`}>
              <span>Order complete</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Content Area for Checkout */}
      <main className="wd-content-layout content-layout-wrapper container wd-builder-off" role="main">
        {checkoutPage === "cart" && (
          // Cart Content View
          <div id="wd-cart-page-333">
            <h1>🛒 Your Cart</h1>
            {cart.length > 0 ? (
              <>
                <table id="cartTable" className="cart-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Category</th>
                      <th>Price</th>
                      <th>Qty</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody id="cartBody">
                    {cart.map((item) => (
                      <tr key={item.productId}>
                        <td>
                          <a href={item.link} target="_blank" rel="noopener noreferrer">
                            {item.title}
                          </a>
                        </td>
                        <td>{item.category}</td>
                        <td>₹{formatPrice(item.price)}</td>
                        <td>
                          <button className="qty-btn" onClick={() => updateQuantity(item.productId, -1)}>-</button>
                          {item.quantity}
                          <button className="qty-btn" onClick={() => updateQuantity(item.productId, 1)}>+</button>
                        </td>
                        <td>
                          <button className="remove-btn" onClick={() => removeFromCart(item.productId)}>Remove</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="total" id="cartTotal">
                  Total: ₹{cartTotal.toFixed(2)}
                </div>
                <div className="mt-4 text-right">
                    <button
                        className="responsive-btn"
                        onClick={() => setCheckoutPage('checkout')}
                        disabled={cart.length === 0}
                    >
                        Proceed to Checkout
                    </button>
                </div>
              </>
            ) : (
              // Empty Cart Message
              <div className="wd-content-area site-content" id="post-380" style={{ display: 'block' }}>
                <article className="entry-content post-380 page type-page status-publish hentry">
                  <div className="woocommerce">
                    <div className="woocommerce-notices-wrapper"></div>
                    <p className="cart-empty wd-empty-page wc-empty-cart-message">
                      Your cart is currently empty.
                    </p>
                    <div className="wd-empty-page-text">
                      Before proceeding to checkout you must add some products to your shopping cart. You will find a lot of interesting products on our "Shop" page.
                    </div>
                    <p className="return-to-shop">
                      <Link className="button wc-backward" to="/courses">
                        Return to shop
                      </Link>
                    </p>
                  </div>
                </article>
              </div>
            )}
          </div>
        )}

        {checkoutPage === "checkout" && (
          // Checkout Form View
          <div className="woocommerce-checkout">
            <form onSubmit={handleSubmitOrder} className="checkout woocommerce-checkout">
              <div className="col2-set" id="customer_details">
                <div className="col-1">
                  <div className="woocommerce-billing-fields">
                    <h3 className="text-xl font-bold mb-4">BILLING DETAILS</h3>
                    <div className="woocommerce-billing-fields__field-wrapper">
                      <p className="form-row form-row-first validate-required">
                        <label htmlFor="billing_first_name">First name <abbr className="required" title="required">*</abbr></label>
                        <input type="text" className="input-text" name="firstName" id="billing_first_name" value={billingDetails.firstName} onChange={handleBillingChange} required />
                      </p>
                      <p className="form-row form-row-last validate-required">
                        <label htmlFor="billing_last_name">Last name <abbr className="required" title="required">*</abbr></label>
                        <input type="text" className="input-text" name="lastName" id="billing_last_name" value={billingDetails.lastName} onChange={handleBillingChange} required />
                      </p>
                      <p className="form-row form-row-last validate-required">
                        <label htmlFor="billing_email">Email <abbr className="required" title="required">*</abbr></label>
                        <input type="email" className="input-text" name="email" id="billing_email" value={billingDetails.email} onChange={handleBillingChange} required />
                      </p>
                      <p className="form-row form-row-last validate-required">
                        <label htmlFor="billing_contact">Contact <abbr className="required" title="required">*</abbr></label>
                        <input type="text" maxLength={10} className="input-text" name="contact" id="billing_contact" value={billingDetails.contact} onChange={handleBillingChange} oninput="this.value = this.value.replace(/[^0-9]/g, '')" required />
                      </p>
                      <p className="form-row form-row-wide address-field validate-required">
                        <label htmlFor="billing_address_1">Street address <abbr className="required" title="required">*</abbr></label>
                        <input type="text" className="input-text" name="streetAddress" id="billing_address_1" placeholder="House number and street name" value={billingDetails.streetAddress} onChange={handleBillingChange} required />
                      </p>
                      <p className="form-row form-row-wide address-field">
                        <input type="text" className="input-text" name="apartmentSuite" id="billing_address_2" placeholder="Apartment, suite, unit, etc. (optional)" value={billingDetails.apartmentSuite} onChange={handleBillingChange} />
                      </p>
                      <p className="form-row form-row-wide address-field validate-required" id="billing_city_field">
                        <label htmlFor="billing_city">Town / City <abbr className="required" title="required">*</abbr></label>
                        <input type="text" className="input-text" name="townCity" id="billing_city" value={billingDetails.townCity} onChange={handleBillingChange} required />
                      </p>
                      <p className="form-row form-row-wide address-field validate-required" id="billing_state_field">
                        <label htmlFor="billing_state">State / County <abbr className="required" title="required">*</abbr></label>
                        <select name="stateCounty" id="billing_state" className="state_select" value={billingDetails.stateCounty} onChange={handleBillingChange} required>
                          <option value="Tamil Nadu">Tamil Nadu</option>
                          <option value="Bihar">Bihar</option>
                          <option value="Haryana">Haryana</option>
                          <option value="Andhra Pradesh">Andhra Pradesh</option>
                          <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                          <option value="Assam">Assam</option>
                          <option value="Chhattisgarh">Chhattisgarh</option>
                          <option value="Gujarat">Gujarat</option>
                          <option value="Himachal Pradesh">Himachal Pradesh</option>
                          <option value="Jharkhand">Jharkhand</option>
                          {/* Add other states as needed */}
                        </select>
                      </p>
                      <p className="form-row form-row-wide address-field validate-required validate-postcode" id="billing_postcode_field">
                        <label htmlFor="billing_postcode">Postcode/ZIP <abbr className="required" title="required">*</abbr></label>
                        <input type="text" maxLength={6} className="input-text" name="postcodeZIP" id="billing_postcode" value={billingDetails.postcodeZIP} onChange={handleBillingChange} required />
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-2">
                  <div className="woocommerce-checkout-review-order">
                    <h3 id="order_review_heading" className="text-xl font-bold mb-4">YOUR ORDER</h3>
                    <table className="shop_table woocommerce-checkout-review-order-table">
                      <thead>
                        <tr>
                          <th className="product-name">Product</th>
                          <th className="product-total">Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cart.map((item) => (
                          <tr className="cart_item" key={item.productId}>
                            <td className="product-name">
                              {item.title} <strong className="product-quantity">× {item.quantity}</strong>
                            </td>
                            <td className="product-total">
                              <span className="woocommerce-Price-amount amount">
                                <bdi><span className="woocommerce-Price-currencySymbol">₹</span>{formatPrice(item.price) * item.quantity}</bdi>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr className="cart-subtotal">
                          <th>Subtotal</th>
                          <td>
                            <span className="woocommerce-Price-amount amount">
                              <bdi><span className="woocommerce-Price-currencySymbol">₹</span>{cartTotal.toFixed(2)}</bdi>
                            </span>
                          </td>
                        </tr>
                        <tr className="order-total">
                          <th>Total</th>
                          <td>
                            <span className="woocommerce-Price-amount amount">
                              <bdi><span className="woocommerce-Price-currencySymbol">₹</span>{cartTotal.toFixed(2)}</bdi>
                            </span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>

                    <div className="woocommerce-checkout-payment">
                      <h3 className="text-lg font-semibold mb-2">Cashfree Payments</h3>
                      <div className="payment_method_cashfree">
                        {/* <img src="images/Cashfree_Payments_Logo.png" alt="Cashfree Payments" className="w-24 h-auto" /> */}
                        <div className="payment_box payment_method_cashfree">
                          <p>Pay securely via Card/Net Banking/Wallet via Cashfree.</p>
                        </div>
                      </div>
                      <div className="form-row place-order">
                        <p className="text-xs text-gray-600 mt-4">
                          Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our <Link to="/privacy-policy" className="text-blue-600 hover:underline">privacy policy</Link>.
                        </p>
                        <button type="submit" className="responsive-btn mt-4 w-full">Place order</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        {checkoutPage === "order-complete" && (
          // Order Complete View (simple placeholder)
          <div className="wd-content-area site-content text-center py-10">
            <h1 className="text-3xl font-bold text-green-600 mb-4">Payment Failed</h1>
            <p className="text-lg text-gray-700 mb-6" style={{color:"red"}}>Payment Gateway required</p>
            <Link to="/courses" className="responsive-btn">Continue Shopping</Link>
          </div>
        )}
      </main>
    </>
  );
};

export default CheckoutPage;
